/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import firebase from 'firebase/app'
import { Modal, Form, TextArea, Button, Input } from 'semantic-ui-react'

const CREDIT_TYPES = [
  { text: 'Deposit', value: 'deposit' },
  { text: 'Commission', value: 'commission' },
  { text: 'Delivery fee', value: 'deliveryFee' },
  { text: 'Cash Out', value: 'cashOut' }
]

class CreditModal extends React.Component {
  state = {
    credit: 0,
    creditType: 'deposit',
    description: '',
    loading: false,
  }

  validateAndVerifyCredit = () => {
    const { credit, creditType } = this.state
    const { cashBalance } = this.props

    if (creditType === 'cashOut') {
      if (Number(credit) >= 0) {
        alert('Cashout must be less than 0')
        return false
      }
    }

    if (creditType === 'cashOut') {
      if(Number(credit) + cashBalance < 0) {
        alert(`Cashout must not be greater than $${cashBalance}`)
        return false
      }
    }

    if (creditType === 'deposit') {
      if (Number(credit <= 0) ) {
        alert(`Deposit must not be greater than 0`)
        return false
      }
    }

    if (credit === '' || credit === 0) {
      this.creditInput.focus()

      return false
    }

    return window.confirm('Are you sure to add more credit to this Driver?')
  }

  onSubmit = async () => {
    const { credit, description, creditType } = this.state
    const { driverUid, auth, onClose } = this.props

    const confirmation = this.validateAndVerifyCredit()

    if (!confirmation) return

    this.setState({ loading: true })
    const creditKey = firebase.database().ref(`deliverer_credits/${driverUid}`).push().key

    const updates = {
      [`deliverer_credits/${driverUid}/${creditKey}`]: {
        description,
        type: creditType,
        handler: auth.email,
        auto_calculate: true,
        value: Number(parseFloat(credit).toFixed(2)),
        created_at: firebase.database.ServerValue.TIMESTAMP,
        updated_at: firebase.database.ServerValue.TIMESTAMP,
      }
    }

    const err = await firebase.database().ref().update(updates)

    if (err) alert(err)

    this.setState({
      loading: false,
      credit: 0,
      creditType: 'deposit',
      description: '',
    })

    onClose()
  }

  render() {
    const { visible, onClose } = this.props
    const { credit, creditType, description, loading } = this.state

    return (
      <Modal
        open={visible}
        onClose={onClose}
      >
        <Modal.Header>Add Credit</Modal.Header>
        <Modal.Content>
          <Form onSubmit={this.onSubmit}>
            <Form.Field required>
              <label>Credit value</label>
              <Input
                ref={ref => { this.creditInput = ref }}
                label='$'
                type='number'
                name='creditInput'
                value={credit}
                placeholder='Amount'
                onChange={e => this.setState({ credit: e.target.value })}
              />
            </Form.Field>
            <Form.Select
              fluid
              label='Credit Type'
              options={CREDIT_TYPES}
              placeholder='Status'
              value={creditType}
              onChange={(e, data) => this.setState({ creditType: data.value })}
            />
            <Form.Field>
              <label>Description</label>
              <TextArea
                placeholder='Credit description...'
                name="creditDescription"
                value={description}
                onChange={e => this.setState({ description: e.target.value })}
              />
            </Form.Field>
            <Button
              type='submit'
              loading={loading}
              disabled={loading}
            >
              Add
            </Button>
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

export default CreditModal


// WEBPACK FOOTER //
// ./src/containers/drivers/detail/CreditModal.js